export interface IMinMax {
    Min: number;
    Max: number;
}

export class MinMax implements IMinMax {
    public Min: number;
    public Max: number;
    constructor(
        minMaxProps: any,
    ) {
        this.Min = minMaxProps.min;
        this.Max = minMaxProps.max;
    }
}
